module.exports = __webpack_public_path__ + "img/stackslash-process-1.9b4535d9.jpg";